<script>
  export let className = "";
  export let height = 1;
  export let title = "Star";
</script>

<svg
  class="{className}"
  height="{`${height}em`}"
  viewBox="0 0 20 20"
  focusable="false"
  role="img"
  aria-hidden="true"
>
  <path
    d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955
    6.572.955-4.756 4.635 1.123 6.545z"
  ></path>
</svg>
<span class="visually-hidden">{title}</span>
